import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { UserService } from '../../layout/service/user.service';

@Component({
    selector: 'app-testimony-image',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        TableModule,
        DialogModule,
        InputTextModule,
        FileUploadModule,
        ToastModule,
        ConfirmDialogModule
    ],
    providers: [MessageService, ConfirmationService],
    template: `
        <div class="mx-auto px-6 py-8">
            <div class="flex justify-between items-center mb-6">
                <div>
                    <h1 class="text-3xl font-bold text-gray-900">Kelola Testimoni Gambar</h1>
                    <p class="text-gray-600">Daftar testimoni gambar dari customer</p>
                </div>
                <p-button
                    (onClick)="openNew()"
                    severity="success"
                    icon="pi pi-plus"
                    label="Tambah Testimoni"
                    size="large">
                </p-button>
            </div>

            <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <p-table
                    [value]="testimonies"
                    [loading]="loading"
                    [paginator]="true"
                    [rows]="10"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} testimoni"
                    [rowsPerPageOptions]="[5, 10, 25]"
                    styleClass="p-datatable-striped">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Gambar</th>
                            <th>Nama</th>
                            <th>Aksi</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-testimony>
                        <tr>
                            <td>
                                <img *ngIf="testimony.path" [src]="'https://oscemediko.id/api-timer/' + testimony.path"
                                     alt="{{ testimony.name }}"
                                     class="w-16 h-16 object-cover rounded-lg border border-gray-200" />
                                <div *ngIf="!testimony.path" class="w-16 h-16 bg-gray-200 rounded-lg border border-gray-200 flex items-center justify-center">
                                    <i class="pi pi-image text-gray-400"></i>
                                </div>
                            </td>
                            <td>{{ testimony.name }}</td>
                            <td>
                                <p-button
                                    (onClick)="editTestimony(testimony)"
                                    icon="pi pi-pencil"
                                    severity="info"
                                    size="small"
                                    class="mr-2">
                                </p-button>
                                <p-button
                                    (onClick)="deleteTestimony(testimony)"
                                    icon="pi pi-trash"
                                    severity="danger"
                                    size="small">
                                </p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" class="text-center py-8">
                                <i class="pi pi-image text-4xl text-gray-400 mb-4 block"></i>
                                <p class="text-gray-500">Belum ada testimoni gambar</p>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        <!-- Dialog for Add/Edit -->
        <p-dialog
            [(visible)]="testimonyDialog"
            [style]="{width: '500px'}"
            [header]="editMode ? 'Edit Testimoni' : 'Tambah Testimoni Baru'"
            [modal]="true"
            styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="field">
                    <label for="name">Nama Testimoni</label>
                    <input
                        pInputText
                        id="name"
                        [(ngModel)]="testimony.name"
                        required="true"
                        autofocus
                        class="w-full" />
                </div>
                <div class="field mt-4">
                    <label for="image">Gambar Testimoni</label>
                    <p-fileUpload
                        #fileUpload
                        name="image"
                        [multiple]="false"
                        accept="image/*"
                        [maxFileSize]="5000000"
                        [auto]="false"
                        chooseLabel="Pilih Gambar"
                        uploadLabel="Upload"
                        cancelLabel="Batal"
                        (onSelect)="onFileSelect($event)"
                        (onRemove)="onFileRemove()">
                    </p-fileUpload>
                    <small class="text-gray-500">Format: JPG, PNG, GIF. Maksimal 5MB</small>
                </div>
                <div class="field mt-4" *ngIf="editMode && testimony.image">
                    <label>Gambar Saat Ini</label>
                    <div class="mt-2">
                        <img *ngIf="testimony.image" [src]="'https://oscemediko.id/api-timer' + testimony.image"
                             alt="Current image"
                             class="w-32 h-32 object-cover rounded-lg border border-gray-200" />
                        <div *ngIf="!testimony.image" class="w-32 h-32 bg-gray-200 rounded-lg border border-gray-200 flex items-center justify-center">
                            <i class="pi pi-image text-gray-400 text-2xl"></i>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <p-button
                    (onClick)="hideDialog()"
                    label="Batal"
                    icon="pi pi-times"
                    severity="secondary">
                </p-button>
                <p-button
                    (onClick)="saveTestimony()"
                    label="Simpan"
                    icon="pi pi-check"
                    [loading]="saving"
                    [disabled]="!selectedFile && !editMode">
                </p-button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog></p-confirmDialog>
        <p-toast></p-toast>
    `
})
export class TestimonyImage implements OnInit {
    testimonies: any[] = [];
    testimony: any = {};
    testimonyDialog = false;
    editMode = false;
    loading = false;
    saving = false;
    selectedFile: File | null = null;

    constructor(
        private userService: UserService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {}

    ngOnInit() {
        this.loadTestimonies();
    }

    loadTestimonies() {
        this.loading = true;
        this.userService.getTestimonyImages().then(
            (response) => {
                this.testimonies = response.data || response || [];
                this.loading = false;
            },
            (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Gagal memuat data testimoni'
                });
                this.loading = false;
            }
        );
    }

    openNew() {
        this.testimony = {};
        this.editMode = false;
        this.selectedFile = null;
        this.testimonyDialog = true;
    }

    editTestimony(testimony: any) {
        this.testimony = { ...testimony };
        this.editMode = true;
        this.selectedFile = null;
        this.testimonyDialog = true;
    }

    hideDialog() {
        this.testimonyDialog = false;
        this.testimony = {};
        this.selectedFile = null;
    }

    onFileSelect(event: any) {
        this.selectedFile = event.files[0];
    }

    onFileRemove() {
        this.selectedFile = null;
    }

    saveTestimony() {
        if (!this.testimony.name) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Peringatan',
                detail: 'Nama testimoni harus diisi'
            });
            return;
        }

        if (!this.editMode && !this.selectedFile) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Peringatan',
                detail: 'Gambar harus dipilih'
            });
            return;
        }

        this.saving = true;
        const formData = new FormData();
        formData.append('name', this.testimony.name);

        if (this.editMode) {
            formData.append('id', this.testimony.id);
        }

        if (this.selectedFile) {
            formData.append('image', this.selectedFile);
        }

        const promise = this.editMode
            ? this.userService.updateTestimonyImage(formData)
            : this.userService.addTestimonyImage(formData);

        promise.then(
            () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: this.editMode ? 'Testimoni berhasil diperbarui' : 'Testimoni berhasil ditambahkan'
                });
                this.hideDialog();
                this.loadTestimonies();
                this.saving = false;
            },
            (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Gagal menyimpan testimoni'
                });
                this.saving = false;
            }
        );
    }

    deleteTestimony(testimony: any) {
        this.confirmationService.confirm({
            message: `Apakah Anda yakin ingin menghapus testimoni "${testimony.name}"?`,
            header: 'Konfirmasi Hapus',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Ya, Hapus',
            rejectLabel: 'Batal',
            accept: () => {
                this.userService.deleteTestimonyImage({ id: testimony.id }).then(
                    () => {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Berhasil',
                            detail: 'Testimoni berhasil dihapus'
                        });
                        this.loadTestimonies();
                    },
                    (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Gagal menghapus testimoni'
                        });
                    }
                );
            }
        });
    }
}